<template>
  <v-row class="ml-1 mr-1" justify="center">
    <v-col v-for="(tab, index) in tabs" :key="tab.id" style="max-width: 250px;">
      <scroll-animation :delay="(index + 1) * 100" :replay="false">
        <v-card
            :elevation="3"
            :color="tab.id === activeTab ? 'secondary' : 'lighter-background'"
            class="rounded-lg pa-5 fill-height"
            :class="{'pt-2 pb-2': slim}"
            @click="() => handleClick(tab.id)"
            @mouseover="handleMouseOver"
            @mouseout="handleMouseOut"
        >
          <div
            class="text-center"
            style="font-size: 16px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
            :style="{ color: utils.getColor(tab.color) }"
          >
            {{ tab.translated ? $t(tab.text) : tab.text }}
          </div>
          <div class="d-flex justify-center">
            <v-icon size="32" :icon="tab.icon" :color="utils.getColor(tab.color)"/>
          </div>
        </v-card>
      </scroll-animation>
    </v-col>
  </v-row>
</template>

<script setup>
import anime from 'animejs';
import ScrollAnimation from '@/components/custom/ScrollAnimation.vue';
const emit = defineEmits(['click']);

defineProps({
  tabs: {
    type: Array,
    required: true,
    default: () => [],
  },
  activeTab: {
    type: String,
  },
  slim: {
    type: Boolean,
    default: true,
  },
});

const handleClick = (tabId) => {
  emit('click', tabId);
};

const handleMouseOver = (event) => {
  anime({
    targets: event.currentTarget,
    scale: 1.05,
    duration: 300,
  });
};

const handleMouseOut = (event) => {
  anime({
    targets: event.currentTarget,
    scale: 1.0,
    duration: 300,
  });
};
</script>

<style scoped>
</style>
